var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_3407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3721 4.32235L14.7162 4.97827C14.3294 5.36509 13.7744 5.5501 13.2362 5.44919C11.1507 5.06236 8.91384 5.68465 7.29926 7.29922C5.68468 8.9138 5.0624 11.1507 5.44922 13.2362C5.55014 13.7743 5.36513 14.3294 4.97831 14.7162L4.32239 15.3721C3.38055 16.3139 1.79961 15.843 1.49688 14.5648C0.639134 11.0161 1.59779 7.13104 4.35602 4.3728C7.13107 1.59775 11.0161 0.639095 14.548 1.49684C15.8431 1.79957 16.2972 3.39733 15.3721 4.32235Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6941 8.62792C20.6023 7.71972 22.2001 8.12336 22.5028 9.38475C23.3942 12.9503 22.4524 16.8858 19.6605 19.6777C16.8686 22.4695 12.9331 23.4114 9.36757 22.52C8.10618 22.2004 7.70254 20.6195 8.61074 19.7113L9.26666 19.0554C9.65348 18.6686 10.2085 18.4836 10.7467 18.5845C12.849 18.9881 15.1027 18.3658 16.7173 16.7513C18.3487 15.1199 18.9541 12.8662 18.5505 10.7807C18.4496 10.2425 18.6346 9.68748 19.0214 9.30066L19.6941 8.62792Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9388 2.32099L21.6789 3.061C22.2675 3.64965 22.318 4.54103 21.7966 5.0624L5.06219 21.7968C4.54081 22.3182 3.64943 22.2677 3.06078 21.6791L2.32077 20.9391C1.73212 20.3504 1.68167 19.459 2.20304 18.9377L18.9374 2.20326C19.442 1.68188 20.3502 1.73234 20.9388 2.32099Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86806 3.36372L3.36351 3.86828C2.70759 4.5242 1.64802 4.5242 0.992102 3.86828L0.487547 3.36372C-0.168375 2.7078 -0.168375 1.64824 0.487547 0.992315L0.992102 0.48776C1.64802 -0.168161 2.70759 -0.168161 3.36351 0.48776L3.86806 0.992315C4.52399 1.64824 4.52399 2.7078 3.86806 3.36372Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5124 23.0077L23.0078 23.5122C22.3519 24.1681 21.2923 24.1681 20.6364 23.5122L20.1318 23.0077C19.4759 22.3518 19.4759 21.2922 20.1318 20.6363L20.6364 20.1317C21.2923 19.4758 22.3519 19.4758 23.0078 20.1317L23.5124 20.6363C24.1683 21.2922 24.1683 22.3518 23.5124 23.0077Z",
    fill: "#EBEBEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_3407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogo);
export default __webpack_public_path__ + "static/media/dark_logo.f906a5f8.svg";
export { ForwardRef as ReactComponent };